import {
  Alert,
  Box,
  Button,
  Chip,
  Collapse,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Popover,
  Select,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import api, { baseURL } from "../../conf/api";
import { DataGrid } from "@mui/x-data-grid";
import FilterListIcon from "@mui/icons-material/FilterList";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import { toast } from "react-toastify";
import ReUploadDialogBox from "./components/ReUploadDialogBox";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DownloadingIcon from "@mui/icons-material/Downloading";
import VideoPreviewBox from "./components/VideoPreviewBox";
import CircleIcon from "@mui/icons-material/Circle";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import ModelBox from "../../Components/Dialogs/ModelBox";
import DeleteIcon from '@mui/icons-material/Delete';
import { connect } from "react-redux";
import { useSearchParams } from "react-router-dom";
import CachedIcon from '@mui/icons-material/Cached';
import UserSelector from "../../Components/Selectors/UserSelector";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import VideoStatusDialogBox from "./components/VideoStatusDialogBox.js";
import BugReportIcon from '@mui/icons-material/BugReport';
import ThumbnailCreatorDialog from "./components/ThumbnailCreatorDialog.js";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ConfirmDeleteVideoDialog from "../../Components/Dialogs/ConfirmDeleteVideoDialog.js";


function VideoPreview(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const formatDate = (dateValue) => {
    return dateValue ? new Date(dateValue).toLocaleString() : "00/00/0000, 00:00";
  };


  const initialFilterField = {
    from_date: searchParams.get("from_date") ? dayjs(searchParams.get("from_date")) : dayjs().subtract(7, "days"),
    to_date: searchParams.get("to_date") ? dayjs(searchParams.get("to_date")) : dayjs(),
    sort_by: searchParams.get("sort_by") || "-created_date",
    user: searchParams.get("user") || null,
  };

  const [filters, setFilters] = React.useState(initialFilterField);
  const [isDropBoxConnected, setDropboxStatus] = useState(undefined);
  const [loading, setLoading] = useState(false);
  // const [rejectionDialog, showRejectionDialog] = useState(false);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, selectVideo] = useState({});
  const [uploadDialog, openUploadDialog] = useState(false);
  const [videoPreviewBox, openVideoPreviewBox] = useState(false);
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [status, setStatus] = useState("Approval");
  const [dialogBox, showDialogBox] = useState(false);
  const [confirmDialogBox, showConfirmDialogBox] = useState(false);
  const [anchorLogs, setAnchorLog] = React.useState(null);
  const [thumbnailUploader, setThumbnailUploader] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false);


  const initialPagination = {
    page: parseInt(searchParams.get("page")) || 0,
    rowPerPage: parseInt(searchParams.get("rowPerPage")) || 10,
    count: 0,
  };

  const [pagination, setPagination] = useState(initialPagination);

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const isXs = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const downloadVideo = (url) => {
    if (process.env.NODE_ENV === 'production') {
      url = url.replace(/^http:\/\//, 'https://');
    }
    const link = document.createElement("a");
    link.target = "_blank";
    link.href = url;
    link.download = url.substring(url.lastIndexOf("/") + 1);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleLogView = (event, vid) => {
    event.stopPropagation();
    setAnchorLog(event.currentTarget);
    selectVideo(vid);
  };

  const handleThumbnailupload = (video) => (e) => {
    e.stopPropagation();
    selectVideo(video);
    setThumbnailUploader(true);
  }


  const columns = useMemo(() => [
    props.is_admin && {
      field: "action",
      align: "center",
      headerAlign: "center",
      headerName: "Approve / Reject",
      minWidth: 150,
      renderCell: (params) => (
        <Box display="flex" width="100%" gap={0.5}>
          {/* {!params.row.approved && (
            <Tooltip title="Click to approve">
              <IconButton
                disabled={!isDropBoxConnected}
                onClick={() => {
                  handlePartialUpdate(params.row.id, "approve");
                }}
              >
                <ThumbUpAltIcon
                  color={isDropBoxConnected ? "success" : "grey"}
                />
              </IconButton>
            </Tooltip>
          )} */}
          {params.row.status !== "Pending" &&
            params.row.status !== "Running" &&
            params.row.status !== "INQUEUE" && (
              <Tooltip title="Click to reupload">
                <IconButton
                  aria-label="Reupload video"
                  onClick={(e) => {
                    e.stopPropagation();
                    selectVideo(params.row);
                    openUploadDialog(true);
                  }}
                >
                  <CloudUploadIcon color="primary" />
                </IconButton>
              </Tooltip>
            )}

          {/* {!params.row?.rejected &&
            !params.row?.dropbox_link &&
            params.row.status !== "Running" &&
            params.row.status !== "INQUEUE" && (
              <Tooltip title="Click to reject">
                <IconButton
                  onClick={() => {
                    showRejectionDialog(true);
                    selectVideo(params.row);
                  }}
                >
                  <ThumbDownAltIcon color="error" />
                </IconButton>
              </Tooltip>
            )} */}
          {params.row.status === "Failed" && (
            <Tooltip title="Restart process">
              <IconButton aria-label="Restart process" onClick={handleReStart(params.row.id)}>
                <CloudSyncIcon color="info" />
              </IconButton>
            </Tooltip>
          )}
          {params.row.status !== "Pending" &&
            params.row.status !== "Running" &&
            params.row.status !== "INQUEUE" &&
            !params.row.approved &&
            <Tooltip title="Delete Video">
              <IconButton aria-label="Delete video" onClick={e => { handleDelete(e)(params.row.id) }}>
                <DeleteIcon color="error" />
              </IconButton>
            </Tooltip>
          }
          {params.row.status === "Completed" &&
            <Tooltip title="Permanent delete video">
              <IconButton aria-label="Permanently delete video" onClick={() => {
                selectVideo(params.row);
                showConfirmDialogBox(true);
              }}>
                <DeleteForeverIcon color="error" />
              </IconButton>
            </Tooltip>
          }
        </Box >
      ),
    },
    props.is_admin && {
      field: 'uploading_log',
      headerName: 'Logs',
      align: "center",
      width: 20,
      renderCell: (params) => {
        return (
          <IconButton
            color="primary"
            aria-label="View logs"
            onClick={(event) => handleLogView(event, params.row)}
          >
            <BugReportIcon />
          </IconButton>
        );
      },
    },
    {
      field: "id",
      headerName: "ID",
      minWidth: 90
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: isSmallScreen ? 100 : 120,
    },
    // { field: "id", headerName: "ID", minWidth: 120 },
    { field: "username", headerName: "User" },
    {
      field: "muted",
      headerName: "Muted",
      type: "boolean",
      editable: true,
    },
    {
      field: "file",
      headerName: "Download",
      minWidth: 90,
      renderCell: (params) => (
        <Tooltip title="Download">
          <IconButton
            aria-label="Download video"
            onClick={(e) => {
              e.stopPropagation();
              if (params.row.dropbox_link) {
                downloadVideo(params.row.dropbox_link.replace());
              } else {
                // downloadVideo(params.value);
                selectVideo(params.row);
                openVideoPreviewBox(true);
              }
            }}
          >
            <DownloadingIcon color={"primary"} />
          </IconButton>
        </Tooltip>
      ),
    },
    props.is_admin && {
      field: "thumbnail_url",
      headerName: "Thumbnail",
      minWidth: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const originalLink = params.row.thumbnail_url;
        if (!originalLink) {
          return <Button onClick={handleThumbnailupload(params.row)} sx={{ color: "grey", fontSize: 12 }}>No Image</Button>;
        }

        const thumbnailUrl = originalLink.replace("www.dropbox.com", "dl.dropboxusercontent.com");

        return (
          <Box display="flex" justifyContent="center" width="100%">
            <IconButton aria-label="Change thumbnail" onClick={handleThumbnailupload(params.row)}>
              <img
                src={thumbnailUrl}
                alt="Thumbnail"
                style={{
                  width: 60,
                  height: 40,
                  objectFit: "cover",
                  borderRadius: 4,
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMmyTPv4M5fFPvYLrMzMQcPD_VO34ByNjouQ&s";
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "assert_id",
      headerName: "Assets",
      minWidth: 120,
      renderCell: (params) => params.value ? params.value : <i style={{ color: "grey" }}>none</i>,
    },
    {
      field: "title",
      headerName: "Title",
      editable: true,
      minWidth: isSmallScreen ? 150 : 200,
    },
    {
      field: "created_date",
      type: "datetime",
      headerName: "Created",
      minWidth: isSmallScreen ? 100 : 200,
      valueGetter: (params) => formatDate(params.value)
    },
    {
      field: "duration",
      headerName: "Duration",
      align: "center",
      minWidth: isSmallScreen ? 70 : 90,
      valueGetter: (params) => {
        if (!params.value) {
          return "0 sec";
        }

        const seconds = params.value;

        if (seconds >= 3600) {
          // Convert to hours
          return `${(seconds / 3600).toFixed(1)} hr`;
        } else if (seconds >= 60) {
          // Convert to minutes
          return `${(seconds / 60).toFixed(1)} min`;
        } else {
          // Keep in seconds
          return `${seconds.toFixed(1)} sec`;
        }
      },
    },
    {
      field: "approved",
      headerName: "Approved",
      minWidth: isSmallScreen ? 70 : 90,
      valueGetter: (params) => formatDate(params.value)
    },
    {
      field: "approval_date",
      type: "datetime",
      headerName: "Approval Date",
      minWidth: isSmallScreen ? 150 : 200,
      valueGetter: (params) => formatDate(params.value)
    },
    // {
    //   field: "rejected",
    //   type: "boolean",
    //   headerName: "Rejected",
    //   minWidth: isSmallScreen ? 70 : 90,
    // },
    {
      field: "rejection_note",
      headerName: "Rejection Reason",
      minWidth: isSmallScreen ? 150 : 200,
      renderCell: (params) =>
        params.value ? params.value : <i style={{ color: "grey" }}>none</i>,
    },
    {
      field: "rejected_date",
      type: "datetime",
      headerName: "Rejection Date",
      minWidth: isSmallScreen ? 150 : 200,
      valueGetter: (params) => formatDate(params.value)
    },
    {
      field: "dropbox_link",
      headerName: "DropBox",
      minWidth: isSmallScreen ? 300 : 600,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            {params.value}
          </a>
        ) : (
          <Typography variant="caption">Not link</Typography>
        ),
    },
  ], [isSmallScreen, props.is_admin, isDropBoxConnected]);

  const FetchData = useCallback(async (page = pagination.page, page_size = pagination.rowPerPage) => {
    setLoading(true);
    setFetchError(false);
    setVideos([]);
    try {
      // Format dates correctly
      const formattedFilters = {
        ...filters,
        user: filters.user && (filters.user instanceof Object) ? filters.user?.username : filters.user === "null" ? null : filters.user,
        from_date: filters.from_date ? dayjs(filters.from_date).format("YYYY-MM-DD") : undefined,
        to_date: filters.to_date ? dayjs(filters.to_date).format("YYYY-MM-DD") : undefined,
      };

      const res = await api.get("/videos/api", {
        params: { page: page + 1, page_size, ...formattedFilters }, timeout: 1000 * 60 * 5
      });

      if (res.status === 200) {
        setVideos(res.data.results);
        setPagination((prev) => ({ ...prev, page: page, count: res.data.count }));
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFetchError(true);
    } finally {
      setLoading(false);
    }
  }, [filters, pagination.page, pagination.rowPerPage]);


  useEffect(() => {
    FetchData();
  }, [pagination.page, pagination.rowPerPage, filters]);

  useEffect(() => {
    let params = { ...filters, page: pagination.page, rowPerPage: pagination.rowPerPage };
    if (params["user"]?.username) {
      params["user"] = params["user"].username
    }
    setSearchParams(params);
  }, [pagination.page, pagination.rowPerPage, filters, setSearchParams]);

  const handlePartialUpdate = async (id, fieldName, newValue, successMessage, oldRow) => {
    try {
      const response = await api.patch(`/videos/api/${id}/`, { [fieldName]: newValue });

      toast.success(successMessage || "Video updated successfully");
      return response.data;
    } catch (error) {
      console.error("Error during update:", error);
      toast.error("An error occurred while updating the video.");
      return oldRow;
    }
  };

  const handleReStart = (videoID) => async (e) => {
    e.stopPropagation();
    api
      .get(`/videos/restartvideo/${videoID}`)
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data);
          FetchData();
        }
      })
      .catch((res) => {
        toast.error(res.response.data);
      });
  };
  const handleDelete = (e) => async (videoID, password = undefined) => {
    e.stopPropagation();
    api
      .delete(`/videos/api/${videoID}`, { data: { password: password }, timeout: 1000 * 60 * 5 })
      .then((res) => {
        if (res.status === 204) {
          toast.info(videoID + " Deleted successfully.");
        }
      })
      .catch((res) => {
        toast.error(res.response?.data);
        console.log(res.response)
      }).finally(() => {
        FetchData();
      });

  };
  const handleDateFilter = (_fields) => (newValue) => {
    setFilters((pre) => ({ ...pre, [_fields]: newValue }));
  };
  const VideoDialog = useCallback(() => {
    return (
      <ReUploadDialogBox
        open={uploadDialog}
        setOpen={openUploadDialog}
        selectedVideo={selectedVideo}
        refrashFunc={FetchData}
      />
    );
    // eslint-disable-next-line
  }, [uploadDialog, selectedVideo]);

  const VideoPreviewDialogBox = useCallback(() => {
    return (
      <VideoPreviewBox
        downloadVideo={downloadVideo}
        video={selectedVideo}
        open={videoPreviewBox && selectedVideo.file}
        onClose={() => {
          openVideoPreviewBox(false);
        }}
      />
    );
  }, [videoPreviewBox, selectedVideo]);

  const VideoStatusDialog = useCallback(() => {
    return (
      <VideoStatusDialogBox
        open={dialogBox}
        status={status}
        onClose={() => {
          showDialogBox(false)
        }}
        videos={selectedVideos}
        refrashFunc={FetchData}
      />
    );
  }, [dialogBox, selectedVideos, setStatus]);

  const LogViewDialog = useCallback(() => {
    const open = Boolean(anchorLogs);
    const handleClose = () => {
      setAnchorLog(null);
      selectVideo({});
    }
    return (<Popover
      open={open}
      anchorEl={anchorLogs}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      slotProps={{ style: { maxWidth: 700 } }}
    >
      <Paper elevation={3} style={{ maxHeight: 400, padding: "4px 16px", overflowY: 'auto', whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
        {/* AWS Logs */}
        <Typography variant="h6" gutterBottom>AWS Logs</Typography>
        <Typography
          variant="body2"
          style={{ whiteSpace: 'pre-wrap', marginBottom: 16 }}
        >
          <ul>
            {selectedVideo?.aws_logs && Array.isArray(selectedVideo?.aws_logs) ? selectedVideo.aws_logs.map(l => <li key={l}>{l}</li>) :
              <li>No AWS logs available.</li>
            }
          </ul>
        </Typography>

        <Divider style={{ margin: '16px 0' }} />

        {/* Uploading Logs */}
        <Typography variant="h6" gutterBottom>Uploading Logs</Typography>
        <Typography
          variant="body2"
          style={{ whiteSpace: 'pre-wrap' }}
        >
          <ul>
            {selectedVideo?.uploading_log && Array.isArray(selectedVideo?.uploading_log) ? selectedVideo.uploading_log.map(l => <li key={l}>{l}</li>) :
              <li>No Uploading logs available.</li>
            }
          </ul>
        </Typography>
      </Paper>
    </Popover>)
  }, [anchorLogs, selectedVideo])

  useEffect(() => {
    const CheckDropBoxSatatus = async () => {
      try {
        const res = await api.get("/auth/dropbox/authenticated");

        if (res.status === 200) {
          setDropboxStatus(true);
        }
      } catch (err) {
        setDropboxStatus(false);
        // GetDropboxURL();
      }
    };

    // Run the function initially
    CheckDropBoxSatatus();

    // Set up an interval to run the function every 2 minutes (120000 milliseconds)
    const intervalId = setInterval(CheckDropBoxSatatus, 120000);

    // Clean up the interval when the component is unmounted
    return () => clearInterval(intervalId);
  }, []);

  // const RejectionNoteDialog = useCallback(() => {
  //   const onConfirm = () => {
  //     const note = document.getElementById("rejection_note").value;
  //     if (note && selectedVideo.id) {
  //       handlePartialUpdate(selectedVideo.id, "reject", note);
  //       document.getElementById("rejection_note").value = "";
  //       showRejectionDialog(false);
  //     } else {
  //       toast.warning("Write some note.");
  //     }
  //   };
  //   return (
  //     <ModelBox
  //       open={rejectionDialog}
  //       setOpen={showRejectionDialog}
  //       title={"Rejection Note ( " + selectedVideo.id + " )"}
  //     >
  //       <Box mt={1} textAlign="right">
  //         <TextField
  //           multiline
  //           minRows={4}
  //           id="rejection_note"
  //           fullWidth
  //           placeholder="Cause of rejection."
  //         />
  //         <Button
  //           sx={{ mt: 2, textTransform: "none" }}
  //           variant="contained"
  //           color="warning"
  //           startIcon={<ThumbDownAltIcon color="error" />}
  //           onClick={onConfirm}
  //         >
  //           Confirm reject
  //         </Button>
  //       </Box>
  //     </ModelBox>
  //   );
  //   // eslint-disable-next-line
  // }, [rejectionDialog, selectedVideo]);

  const dateFieldProps = { size: "small", fullWidth: true };
  const sortOptions = [
    ["created_date", "Created date", true],
    ["-created_date", "Created date", false],
    ["uploaded_date", "Upload date", true],
    ["-uploaded_date", "Upload date", false],
    ["approval_date", "Approval date", true],
    ["-approval_date", "Approval date", false],
    ["rejected_date", "Rejected date", true],
    ["-rejected_date", "Rejected date", false],
  ];
  const canApprove = selectedVideos.length > 0 && selectedVideos.every(v => !v.approved);
  const canReject = selectedVideos.length > 0 && selectedVideos.every(row => (!row?.rejected && !row?.dropbox_link && row.status !== "Running" && row.status !== "INQUEUE"));
  const focusRing = { "&:focus-visible": { outline: "2px solid", outlineColor: "primary.main", outlineOffset: 2 } };

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1400, mx: "auto", width: "100%" }}>
      {/* Header */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "flex-start" }}
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Box>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, fontSize: { xs: "1.5rem", md: "2.125rem" } }}>
            Videos
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Review, approve and manage uploaded videos.
          </Typography>
        </Box>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ xs: "stretch", sm: "center" }}>
          {props.is_admin && isDropBoxConnected !== undefined && (
            <Chip
              component={isDropBoxConnected ? "div" : "a"}
              href={isDropBoxConnected ? undefined : `${baseURL}/auth/dropbox/access_token/`}
              target={isDropBoxConnected ? undefined : "_blank"}
              clickable={!isDropBoxConnected}
              icon={<CircleIcon fontSize="small" />}
              color={isDropBoxConnected ? "success" : "error"}
              variant="outlined"
              label={`Storage ${isDropBoxConnected ? "connected" : "disconnected, click to authenticate"}`}
              sx={{ height: 44, justifyContent: "flex-start" }}
            />
          )}
          <Button
            variant="outlined"
            startIcon={<CachedIcon />}
            onClick={() => FetchData()}
            disabled={loading}
            sx={{ minHeight: 44 }}
          >
            Refresh
          </Button>
          {isXs && (
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setFiltersOpen(o => !o)}
              aria-expanded={filtersOpen}
              aria-controls="video-filters"
              sx={{ minHeight: 44 }}
            >
              {filtersOpen ? "Hide filters" : "Show filters"}
            </Button>
          )}
        </Stack>
      </Stack>

      <Stack spacing={2}>
        {/* Filters */}
        <Collapse in={!isXs || filtersOpen} id="video-filters">
          <Paper variant="outlined" sx={{ borderRadius: 2, p: { xs: 2, md: 3 } }}>
            <Box
              sx={{
                display: "grid",
                gap: 2,
                gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", lg: "repeat(4, 1fr)" },
                alignItems: "start",
              }}
            >
              <Box>
                <UserSelector
                  filters={{ is_creator: true, is_promouser: false }}
                  value={filters.user}
                  onChange={(e, _u) => { setPagination(pre => ({ ...pre, page: 0 })); setFilters(pre => ({ ...pre, user: _u })) }}
                />
              </Box>
              <FormControl fullWidth size="small">
                <InputLabel id="video-sort-label">Sort by</InputLabel>
                <Select
                  labelId="video-sort-label"
                  label="Sort by"
                  value={filters.sort_by}
                  onChange={e => setFilters(pre => ({ ...pre, sort_by: e.target.value }))}
                >
                  {sortOptions.map(([value, label, asc]) => (
                    <MenuItem key={value} value={value} sx={{ minHeight: 44 }}>
                      <Box display="flex" alignItems="center" gap={1}>
                        {asc ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />}
                        {label}
                      </Box>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From"
                  value={filters.from_date}
                  onChange={handleDateFilter("from_date")}
                  slotProps={{ textField: dateFieldProps }}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To"
                  value={filters.to_date}
                  onChange={handleDateFilter("to_date")}
                  slotProps={{ textField: dateFieldProps }}
                />
              </LocalizationProvider>
            </Box>
          </Paper>
        </Collapse>

        {fetchError && (
          <Alert
            severity="error"
            action={<Button color="inherit" size="small" onClick={() => FetchData()} sx={{ minHeight: 36 }}>Retry</Button>}
          >
            Could not load videos. Check your connection and try again.
          </Alert>
        )}

        {/* Bulk actions */}
        {(canApprove || canReject) && (
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1} aria-live="polite">
            {canApprove && (
              <Tooltip title={isDropBoxConnected ? "Approve selected videos" : "Storage must be connected to approve"}>
                <span>
                  <Button
                    fullWidth={isXs}
                    disabled={!isDropBoxConnected}
                    startIcon={<ThumbUpAltIcon />}
                    color="success"
                    variant="contained"
                    sx={{ minHeight: 44 }}
                    onClick={() => {
                      setStatus("Approval");
                      showDialogBox(true)
                    }}
                  >
                    {`Approve selected (${selectedVideos.length})`}
                  </Button>
                </span>
              </Tooltip>
            )}
            {canReject && (
              <Tooltip title={isDropBoxConnected ? "Reject selected videos" : "Storage must be connected to reject"}>
                <span>
                  <Button
                    fullWidth={isXs}
                    disabled={!isDropBoxConnected}
                    startIcon={<ThumbDownAltIcon />}
                    color="error"
                    variant="contained"
                    sx={{ minHeight: 44 }}
                    onClick={() => {
                      setStatus("Rejection")
                      showDialogBox(true)
                    }}
                  >
                    {`Reject selected (${selectedVideos.length})`}
                  </Button>
                </span>
              </Tooltip>
            )}
          </Stack>
        )}

        {/* Data */}
        <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden", width: "100%", maxWidth: "100%" }}>
          <Box sx={{ height: { xs: 520, md: pagination.rowPerPage > 40 ? 700 : 560 }, width: "100%" }}>
            <DataGrid
              columns={columns}
              rows={videos}
              loading={loading}
              checkboxSelection
              rowHeight={44}
              sx={{
                border: 0,
                "& .MuiDataGrid-columnHeaders": { bgcolor: "action.hover", fontWeight: 600 },
                "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus-within": {
                  outline: "2px solid", outlineColor: "primary.main", outlineOffset: -2,
                },
                ...focusRing,
              }}
              slots={{
                noRowsOverlay: () => (
                  <Stack alignItems="center" justifyContent="center" spacing={1} sx={{ height: "100%", p: 2, textAlign: "center" }}>
                    <VideocamOffIcon aria-hidden="true" sx={{ fontSize: 40, color: "text.disabled" }} />
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>No videos found</Typography>
                    <Typography variant="body2" color="text.secondary">Try widening the date range or clearing the user filter.</Typography>
                  </Stack>
                ),
              }}
              paginationMode="server"
              paginationModel={{
                page: pagination.page,
                pageSize: pagination.rowPerPage,
              }}
              rowCount={pagination.count}
              pageSizeOptions={[5, 10, 50, 100]}
              onPaginationModelChange={(newPage) => {
                if (!loading) {
                  const { page, pageSize } = newPage;
                  setPagination((prev) => ({
                    ...prev,
                    page: page,
                    rowPerPage: pageSize,
                  }));
                }
              }}
              onRowSelectionModelChange={(selectedIds) => {
                setSelectedVideos(videos.filter(v => selectedIds.includes(v.id)));
              }}
              isCellEditable={(params) => !params.row.approved}
              processRowUpdate={async (newRow, oldRow) => {
                if (oldRow.approved) {
                  toast.error("This video is already approved and cannot be edited.");
                  return oldRow; // revert change
                }

                if (newRow.muted !== oldRow.muted) {
                  await handlePartialUpdate(newRow.id, "muted", newRow.muted, `Muted set to ${newRow.muted}`, oldRow);
                }
                if (newRow.title !== oldRow.title) {
                  if (newRow.title?.length > 50 || newRow.title?.length < 3) {
                    toast.error("Title length should be b/w  3-50 characters.");
                    return oldRow;
                  }
                  await handlePartialUpdate(newRow.id, "title", newRow.title, `Title updated to ${newRow.title}`, oldRow);
                }

                return newRow; // update row in UI
              }}
              experimentalFeatures={{ newEditingApi: true }}
              rowSelectionModel={selectedVideos.map(v => v.id)}
            />
          </Box>
        </Paper>
      </Stack>

      <LogViewDialog />
      <VideoPreviewDialogBox />
      <VideoDialog />
      <VideoStatusDialog />
      <ThumbnailCreatorDialog open={thumbnailUploader && props.is_admin} video={selectedVideo} setOpen={setThumbnailUploader} refreshFunc={() => { FetchData(); setThumbnailUploader(false) }} />
      {/* <RejectionNoteDialog /> */}
      <ConfirmDeleteVideoDialog open={confirmDialogBox} onClose={() => showConfirmDialogBox(false)} video={selectedVideo} onConfirm={handleDelete} />
    </Box >
  );
}

const mapStatesToProps = (state) => {
  return {
    user: state.user,
    is_admin: state.user?.is_staff,
  };
};

export default connect(mapStatesToProps, null)(VideoPreview);
